module.exports = __webpack_public_path__ + "static/media/arrow-right.00368fa5.svg";